import { ArrayFilter } from './ArrayFilter';

export default ArrayFilter;
